/**
 * Convert a well-formed `**bold**` pair into <strong>.
 *
 * A handful of stems and explanations still carry markdown emphasis, so a TARA
 * option reads "could **not** be achieved" with the asterisks showing.
 *
 * Deliberately narrow. The content may not contain an asterisk, a line break,
 * an angle bracket or a dollar, and must be short. TMUA-0002-p2 q8 uses `(**)`
 * as the name of a statement and refers to it twice in one field; the text
 * between those two markers spans HTML and maths, so it is not matched. Several
 * UCAT explanations carry a single stray `**` with no partner, which is left as
 * it is rather than guessed at.
 */
export function boldMarkdownToHtml(text) {
  if (typeof text !== 'string' || !text.includes('**')) return text || '';
  return text.replace(/\*\*([^*\n<>$]{1,60})\*\*/g, '<strong>$1</strong>');
}
